import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getTransactionsReports } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';
import { PAGINATION_LIMIT } from "../../../constants/Preferences";
export const useTransactionsReports = (mpacBaseUrl, partnerId, queryParams) => {
  const {
    result,
    error,
    pending
  } = hooks.usePromise(() => getTransactionsReports(mpacBaseUrl, partnerId, _objectSpread(_objectSpread({}, queryParams), {}, {
    limit: String(PAGINATION_LIMIT)
  })), [queryParams]);

  if (error) {
    log.error('TransactionsReports/hooks', "Failed to retrieve Transactions Reports", {
      error
    });
  }

  return {
    pending,
    error,
    transactionsAPIResponse: result
  };
};